import React from "react";

const AboutShape = () => {
	return (
		<svg width={823} viewBox="0 0 823 825" fill="none">
			<g filter="url(#filter0_f_31_289)">
				<path
					d="M325.982 606.282C432.784 653.624 557.651 605.217 604.882 498.164C652.112 391.109 603.821 265.946 497.018 218.604C390.217 171.262 265.349 219.669 218.118 326.723C170.888 433.777 219.18 558.941 325.982 606.282Z"
					fill="url(#paint0_radial_31_289)"
					fillOpacity="0.6"
				/>
			</g>
			<defs>
				<filter
					id="filter0_f_31_289"
					x={0}
					y="0.443359"
					width={823}
					height={824}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feGaussianBlur
						stdDeviation={100}
						result="effect1_foregroundBlur_31_289"
					/>
				</filter>
				<radialGradient
					id="paint0_radial_31_289"
					cx={0}
					cy={0}
					r={1}
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(821.778 671.903) rotate(-154.386) scale(977.623 889.064)"
				>
					<stop offset="0.281116" stopColor="#00EBFF" />
					<stop offset="0.717189" stopColor="#FF39B0" />
					<stop offset="0.770833" stopColor="#161C1B" />
				</radialGradient>
			</defs>
		</svg>
	);
};

export default AboutShape;
